import {
  appSignals,
  showActionParams,
  showActionParamsNames,
} from "@cayo/shared/components/App/utils";

export const showWizardScheme = (schemeId: string) => {
  const parts = schemeId.split(",");
  const prms: showActionParams = { schemeId };
  if (showActionParamsNames("reloadAfterClose") === parts[1]) {
    prms.reloadAfterClose = true;
    prms.schemeId = parts[0];
  }

  appSignals.send("showAction", undefined);
  appSignals.send("showWizardScheme", prms);
};
